import React from 'react';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { IconButton } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import MultipleCompose from '@material-ui/icons/People';
import { addQuery } from 'Helpers/Query';
import fr from 'facet-rest';
import { openModal } from 'Helpers/ModalHelper';
import modalConsts from 'Consts/ModalNames';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { DataValueMap } from 'Helpers/Testing';

const useStyles = buildUseStyles('BulkCommunicationButton', (theme) => ({
  bulkCommunicationButton: {
    padding: theme.spacing(1),
  },
}));

const BulkCommunicationButton = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const { displayErrorMessage } = useSnackbarContext();

  const { pageContentResource: messagesPageResource } = usePageContentContext();

  return (
    <IconButton
      className={classes.bulkCommunicationButton}
      color={'primary'}
      icon={MultipleCompose}
      size="small"
      title="Bulk Communication"
      aria-label="launch-bulk-communication"
      onClick={() => {
        try {
          // This can't be done using modal context because it would require a massive refactor of bulk communications that we aren't ready to do
          addQuery({ bulkCommunicationLink: messagesPageResource.relationship(fr.relationships.bulkCommunication.name)?.link('related').url() });
          openModal(modalConsts.bulkCommunication);
        } catch (err) {
          displayErrorMessage(err);
        }
      }}
      test={'bulk-communication-button'}
      {...DataValueMap.init('bulk-communication-button').build()}
    />
  );
};

BulkCommunicationButton.defaultProps = {};

BulkCommunicationButton.propTypes = {};

export { BulkCommunicationButton };
